import type { NDateLocale } from './enUS'
import { vi } from 'date-fns/locale'

const dateVi: NDateLocale = {
  name: 'vi-VN',
  locale: vi
}

export default dateVi
